module.exports = __webpack_public_path__ + "static/media/as2tj54.6df2acb4.png";